import React, { useEffect, useRef, useState } from "react";
import "../../../node_modules/tabulator-tables/dist/css/tabulator_bootstrap4.css";
import "../../../node_modules/semantic-ui-css/components/icon.min.css";
import { TabulatorFull as Tabulator } from "tabulator-tables";
import { IAtivosModel, IGatewaysModel } from "../modules/services/core/_models";
import { getDataSetNamePBI, useHttpClient } from "../modules/services/Bundle";
import { RequestMethod } from "../modules/services/core/_enums";
import { CSSProperties } from "react";
import { useAuth } from "../modules/auth";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

// Componente Modal para Edição/Criação
interface AlertModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (data: any, isPrism: boolean) => void;
  initialData: any;
  isPrism: boolean;
  dashboardAlerts: any[];
  users: any[];
}
const nivelOptions = [
  { value: 1, label: "informação" },
  { value: 2, label: "Atenção" },
  { value: 3, label: "Baixo" },
  { value: 4, label: "Médio" },
  { value: 5, label: "Alto" },
  { value: 6, label: "Urgente" },
];

const tipoPlaceOptions = [
  { value: 4, label: "Transito" },
  { value: 5, label: "Móvel" },
  { value: 6, label: "Fixo" },
];

const tipoPrismOptions = [
  { value: 1, label: "Trator" },
  { value: 2, label: "Colhedora" },
  { value: 3, label: "Carreta" },
  { value: 4, label: "Transbordo" },
  { value: 5, label: "Caminhão" },
];

const AlertModal: React.FC<AlertModalProps> = ({ isOpen, onClose, onSubmit, initialData, isPrism, dashboardAlerts, users }) => {
  const { auth } = useAuth();
  const [formData, setFormData] = useState<any>(initialData || {});
const [corporations, setCorporations] = useState<any[]>([]);
  const [allOrganizations, setAllOrganizations] = useState<any[]>([]);
  const [opcoesFiltradas, setOpcoesFiltradas] = useState<any[]>([]); // Serve para Gateways ou Ativos
  const [isLoadingList, setIsLoadingList] = useState(false);

  // Classes CSS usando variáveis do tema bootstrap
  const classes = {
    modalOverlay: "position-fixed top-0 start-0 end-0 bottom-0 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center",
    modalContent: "bg-body p-4 rounded shadow-lg",
    modalTitle: "fs-4 mb-4 text-body",
    form: "d-flex flex-column gap-3",
    formGroup: "form-group",
    label: "form-label text-body mb-1",
    input: "form-control",
    select: "form-select",
    buttonGroup: "d-flex gap-2 mt-4",
    buttonPrimary: "btn btn-primary",
    buttonSecondary: "btn btn-outline-secondary",
    buttonDanger: "btn btn-danger",
  };

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    
    if (name === 'IdCorporation') {
      // Limpa organização e dependentes ao mudar corporação
      setFormData({ ...formData, IdCorporation: value, IdOrganization: undefined, IdGateway: undefined, ativo: undefined });
      return;
    }
    if (name === 'IdOrganization') {
      // Limpa dependentes ao mudar organização
      setFormData({ ...formData, [name]: value, IdGateway: undefined, ativo: undefined });
      return;
    }
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e: any) => {
    e.preventDefault(); // Importante para evitar reload
    onSubmit({ ...formData }, isPrism);
    onClose();
  };

  // 1. Busca Corporações/Organizações (igual ao anterior)
  useEffect(() => {
    if (isOpen) {
        setFormData({ ...(initialData || {}) });
        setOpcoesFiltradas([]); // Reseta a lista ao abrir
        
        // Lógica de buscar User Organizations (Simplificada aqui para foco)
        const fetchOrgData = async () => {
             try {
                const userEmail = auth?.User?.Email;
                if (!userEmail) return;
                const userResp = await fetch(`${backendUrl}/api/User/ByEmail/${encodeURIComponent(userEmail)}`);
                const userId = await userResp.json();
                const orgResp = await fetch(`${backendUrl}/api/UserOrganization/OrgByUser?userId=${userId}`);
                const data = await orgResp.json();

                setCorporations(data.filter((item: any) => item.Idcorporacao === null).map((c:any) => ({ CorporationId: c.OrganizationId, CorporationName: c.OrganizationName })));
                setAllOrganizations(data.filter((item: any) => item.Idcorporacao !== null));
             } catch(e) { console.error(e); }
        };
        fetchOrgData();
    }
  }, [isOpen, auth, initialData]);

  // 2. NOVA LÓGICA: Busca Ativos ou Gateways quando a Organização muda
  useEffect(() => {
    const buscarDependentes = async () => {
        if (!formData.IdOrganization || !isOpen) {
            setOpcoesFiltradas([]);
            return;
        }

        setIsLoadingList(true);
        try {
            const dataSetNamePBI = getDataSetNamePBI();
            const orgObj = allOrganizations.find(o => String(o.OrganizationId) === String(formData.IdOrganization));
            const orgName = orgObj ? orgObj.OrganizationName : '';

            const queryParams = new URLSearchParams();
            if (dataSetNamePBI) queryParams.append('datasetName', dataSetNamePBI);
            
            // Corrige o envio do array de string conforme swagger
            if (orgName) queryParams.append('organization', orgName.trim());

            const endpoint = isPrism 
                ? '/Gerenciamento/PowerBI/ObterAtivosByOrg' 
                : '/Gerenciamento/PowerBI/ObterGatewaysByOrg';

            // Rota corrigida (sem /api fixo se já estiver na baseURL ou ajustado conforme seu ambiente)
            const fullUrl = `${backendUrl}${endpoint}?${queryParams.toString()}`;
            
            const response = await fetch(fullUrl);
            
            if (response.ok) {
                const data = await response.json();
                // AQUI ESTAVA O ERRO: Precisamos acessar .Payload
                if (data && Array.isArray(data.Payload)) {
                    setOpcoesFiltradas(data.Payload);
                } else {
                    console.warn("Payload vazio ou formato inválido", data);
                    setOpcoesFiltradas([]);     
                }
            } else {
                setOpcoesFiltradas([]);
            }
        } catch (error) {
            console.error("Erro ao buscar lista filtrada:", error);
            setOpcoesFiltradas([]);
        } finally {
            setIsLoadingList(false);
        }
    };

    buscarDependentes();
  }, [formData.IdOrganization, isPrism, allOrganizations, isOpen]);

  if (!isOpen) return null;
  const alertasFiltrados = dashboardAlerts.filter((alert) => {
    const titulo = (alert.Titulo || "").toLowerCase();
    const temGateway = titulo.includes("gateway");

    return isPrism ? !temGateway : temGateway;
  });

  return (
    <div className={classes.modalOverlay}>
      <div className={classes.modalContent} style={{ maxHeight: '90vh', overflowY: 'auto' }}>
        <h2 className={classes.modalTitle}>{initialData ? "Editar Alerta" : "Criar Alerta"}</h2>
        <form onSubmit={handleSubmit} className={classes.form}>
            
            <div className={classes.formGroup}>
                <label className={classes.label}>Corporação:</label>
                <select name="IdCorporation" value={formData.IdCorporation || ''} onChange={handleChange} className={classes.select}>
                    <option value="">Selecione...</option>
                    {corporations.map((c) => <option key={c.CorporationId} value={c.CorporationId}>{c.CorporationName}</option>)}
                </select>
            </div>

            <div className={classes.formGroup}>
                <label className={classes.label}>Organização:</label>
                <select name="IdOrganization" value={formData.IdOrganization || ''} onChange={handleChange} className={classes.select} disabled={!formData.IdCorporation}>
                    <option value="">Selecione...</option>
                    {allOrganizations.filter((org: any) => String(org.Idcorporacao) === String(formData.IdCorporation))
                        .map((org: any) => <option key={org.OrganizationId} value={org.OrganizationId}>{org.OrganizationName}</option>)}
                </select>
            </div>

          <div className={classes.formGroup}>
            <label className={classes.label}>Alerta:</label>
            <select
              name="IdDashboard"
              value={formData.IdDashboard || ""}
              onChange={handleChange}
              className={classes.select}
            >
              <option value="">Selecione um alerta</option>
              {alertasFiltrados.map((alert) => (
                <option key={alert.Id} value={alert.Id}>
                  {alert.Titulo}
                </option>
              ))}
            </select>
          </div>

          <div className="row">
            <div className={isPrism ? "col-12" : "col-12"}>
                <div className={classes.formGroup}>
                    <label className={classes.label}>Nível:</label>
                    <select
                        name="nivel"
                        value={formData.nivel || ""}
                        onChange={handleChange}
                        className={classes.select}
                        required
                    >
                    <option value="">Selecione...</option>
                    {nivelOptions.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                    ))}
                    </select>
                </div>
            </div>
</div>
            {/* O TIPO agora só aparece para GATEWAYS (!isPrism) */}
            {!isPrism && (
                <div className="col-12">
                    <div className={classes.formGroup}>
                        <label className={classes.label}>Tipo (Tag):</label>
                        <select
                            name="tipo"
                            value={formData.tipo || ""}
                            onChange={handleChange}
                            className={classes.select}
                            required
                        >
                        <option value="">Selecione...</option>
                        {tipoPlaceOptions.map((opt) => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                        ))}
                        </select>
                    </div>
                </div>
            )}
          

          <div className={classes.formGroup}>
                <label className={classes.label}>
                    {isPrism ? "Ativo:" : "Gateway:"}
                    {isLoadingList && <span className="ms-2 spinner-border spinner-border-sm text-primary"></span>}
                </label>
                
                <select
                    name={isPrism ? "ativo" : "IdGateway"} 
                    value={(isPrism ? formData.ativo : formData.IdGateway) || ""}
                    onChange={handleChange}
                    className={classes.select}
                    disabled={!formData.IdOrganization || isLoadingList}
                >
                    <option value="">
                        {formData.IdOrganization 
                            ? (isPrism ? "Todos / Nenhum específico" : "Selecione o Gateway...") 
                            : "Selecione a Organização primeiro"}
                    </option>
                    
                    {opcoesFiltradas.map((item: any) => {
                        // LÓGICA DE MAPEAMENTO CORRIGIDA COM BASE NO SEU JSON
                        let value;
                        let label;

                        if (isPrism) {
                            // Mapeamento para ATIVOS
                            value = item.IdPrism; 
                            // Exibe: "Código - Descrição" ou só o Código
                            label = item.Ativo ? `${item.Ativo} - ${item.Descricao || ''}` : item.Descricao;
                        } else {
                            // Mapeamento para GATEWAYS
                            value = item.IdGateway;
                            // Exibe: Gateway (Serial)
                            label = `${item.Gateway} (${item.SerialNumber || ''})`;
                        }
                        
                        // Proteção caso venha dado incompleto
                        if (!value) return null; 

                        return <option key={value} value={value}>{label}</option>
                    })}
                </select>
            </div>

          <div className={classes.formGroup}>
            <label className={classes.label}>Alerta (minutos):</label>
            <input
              type="number"
              name="alertaMinutos"
              value={formData.alertaMinutos || 0}
              onChange={handleChange}
              className={classes.input}
            />
          </div>

          <div className={classes.formGroup}>
            <label className={classes.label}>Solução (minutos):</label>
            <input
              type="number"
              name="solucaoMinutos"
              value={formData.solucaoMinutos || 0}
              onChange={handleChange}
              className={classes.input}
            />
          </div>

          <div className={classes.formGroup}>
            <label className={classes.label}>Responsável:</label>
            <select
              name="IdUserResponsible"
              value={formData.IdUserResponsible || ""}
              onChange={handleChange}
              className={classes.select}
            >
              <option value="">Selecione um responsável</option>
              {[...users]
                .sort((a, b) => (a.Name || "").localeCompare(b.Name || ""))
                .map((user) => (
                  <option key={user.Id} value={user.Id}>
                    {user.Name}
                  </option>
              ))}
            </select>
          </div>

          <div className={classes.buttonGroup}>
            <button type="submit" className={classes.buttonPrimary}>
              Salvar
            </button>
            <button type="button" onClick={onClose} className={classes.buttonSecondary}>
              Cancelar
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

// Componente Principal
const MenuListaAlertas: React.FC = () => {
  const { auth } = useAuth();
  const tableRef = useRef<HTMLDivElement>(null);
  const [users, setUsers] = useState([]);
  const [alertsLoaded, setAlertsLoaded] = useState(false);
  const [prismDataAll, setPrismDataAll] = useState<any[]>([]);
  const [placeDataAll, setPlaceDataAll] = useState<any[]>([]);
  const [prismData2All, setPrismData2All] = useState<any[]>([]);
  const [placeData2All, setPlaceData2All] = useState<any[]>([]);
  const dataSetNamePBI = getDataSetNamePBI();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEnableModalOpen, setIsEnableModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [rowToDelete, setRowToDelete] = useState<any>(null);
  const [activeTab, setActiveTab] = useState<'ativos' | 'gateways'>('ativos');
  const prismTableRef = useRef<HTMLDivElement>(null);
  const prismTableRef2 = useRef<HTMLDivElement>(null);
  const placeTableRef = useRef<HTMLDivElement>(null);
  const placeTableRef2 = useRef<HTMLDivElement>(null);
  const prismTableInstance = useRef<Tabulator | null>(null);
  const prismTableInstance2 = useRef<Tabulator | null>(null);
  const placeTableInstance = useRef<Tabulator | null>(null);
  const placeTableInstance2 = useRef<Tabulator | null>(null);
  const [gatewayId, setGatewayId] = useState<string | null>(null);
  const [prismEscalate, setPrismEscalate] = useState<any[]>([]);
  const [placeEscalate, setPlaceEscalate] = useState<any[]>([]);
  // filtros
  const [corporationsFilter, setCorporationsFilter] = useState<any[]>([]);
  const [organizationsFilter, setOrganizationsFilter] = useState<any[]>([]);
  const [selectedCorporation, setSelectedCorporation] = useState<string>('');
  const [selectedOrganization, setSelectedOrganization] = useState<string>('');

  // Dados filtrados por corporação
  const prismData = React.useMemo(() => {
    if (!selectedCorporation) return prismDataAll;
    return prismDataAll.filter((item) => String(item.IdCorporation) === selectedCorporation);
  }, [prismDataAll, selectedCorporation]);

  const prismData2 = React.useMemo(() => {
    if (!selectedCorporation) return prismData2All;
    return prismData2All.filter((item) => String(item.IdCorporation) === selectedCorporation);
  }, [prismData2All, selectedCorporation]);

  const placeData = React.useMemo(() => {
    if (!selectedCorporation) return placeDataAll;
    return placeDataAll.filter((item) => String(item.IdCorporation) === selectedCorporation);
  }, [placeDataAll, selectedCorporation]);

  const placeData2 = React.useMemo(() => {
    if (!selectedCorporation) return placeData2All;
    return placeData2All.filter((item) => String(item.IdCorporation) === selectedCorporation);
  }, [placeData2All, selectedCorporation]);

  interface RowData {
    IdOrganization: number;
    IdCorporation?: number;
    IdDashboard: string;
    nivel: string;
    tipo: string;
    IdPlace: string;
    IdGateway: string;
    ativo: string;
    alertaMinutos: number;
    solucaoMinutos: number;
    IdUserResponsible: string;
  }

  const [currentRow, setCurrentRow] = useState<RowData | null>(null);
  const [isPrism, setIsPrism] = useState(true);
  const [dashboardAlerts, setDashboardAlerts] = useState<any[]>([]);
  const [gateways, setGateways] = useState<any[]>([]);


  


  useEffect(() => {
    fetchPrismEscalate();
    fetchPlaceEscalate();
  }, []);


  const fetchPrismEscalate = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/PrismAlertsEscalate`);
      if (!response.ok) throw new Error("Erro ao buscar PrismAlertsEscalate");
      const data = await response.json();
      setPrismEscalate(data);
    } catch (error) {
      console.error("Erro ao buscar PrismAlertsEscalate:", error);
    }
  };

  const fetchPlaceEscalate = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/PlaceAlertsEscalate`);
      if (!response.ok) throw new Error("Erro ao buscar PlaceAlertsEscalate");
      const data = await response.json();
      setPlaceEscalate(data);
    } catch (error) {
      console.error("Erro ao buscar PlaceAlertsEscalate:", error);
    }
  };


  const fetchDashboardAlerts = async () => {
    try {
      const response = await fetch(`${backendUrl}/api/Dashboard`);
      if (!response.ok) throw new Error("Erro ao buscar alertas do dashboard");
      const data = await response.json();
      setDashboardAlerts(data);
    } catch (error) {
      console.error("Erro ao buscar alertas do dashboard:", error);
    }
  };

  useEffect(() => {
    fetchDashboardAlerts();
  }, []);

  // Carregar corporações e organizações para o filtro superior
  useEffect(() => {
    const fetchUserCorporationsAndOrganizations = async () => {
      try {
        const email = auth?.User?.Email;
        if (!email) return;
        const userResp = await fetch(`${backendUrl}/api/User/ByEmail/${encodeURIComponent(email)}`);
        if (!userResp.ok) return;
        const userId = await userResp.json();
        const orgResp = await fetch(`${backendUrl}/api/UserOrganization/OrgByUser?userId=${userId}`);
        if (!orgResp.ok) return;
        const data = await orgResp.json();
        const corps = data.filter((x: any) => x.Idcorporacao === null)
          .map((c: any) => ({ id: c.OrganizationId, name: c.OrganizationName }));
        const orgs = data.filter((x: any) => x.Idcorporacao !== null)
          .map((o: any) => ({ id: o.OrganizationId, name: o.OrganizationName, corpId: o.Idcorporacao }));
        setCorporationsFilter(corps);
        setOrganizationsFilter(orgs);
      } catch (e) {
        console.error('Erro ao carregar corporações/organizações (filtro):', e);
      }
    };
    fetchUserCorporationsAndOrganizations();
  }, [auth]);

  // (Removido) Carregamento de mapa de organizações — passamos a usar apenas os campos vindos diretamente da API de alertas


  // Buscar usuários
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await fetch(`${backendUrl}/api/User/`, { method: "GET", headers: { accept: "*/*" } });
        const responseJson = await response.json();
        setUsers(responseJson);
      } catch (error) {
        console.error("Erro ao buscar dados dos usuários:", error);
      }
    };
    fetchUserData();
  }, []);
  console.log(users);
  // Buscar alertas Prism e Place (considerando filtro de organização)
  const fetchPrismAlerts = async () => {
    try {
      const url = `${backendUrl}/api/PrismAlerts/GetByStatus?status=0${selectedOrganization ? `&org=${encodeURIComponent(selectedOrganization)}` : ''}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Erro HTTP! Status: ${response.status}`);
      const apiData = await response.json();
      const formattedData = apiData.map((item: any) => ({
        id: item.Id, // ID do Alerta
        IdPrism: item.IdPrism, // ID do Ativo (Para o select do Modal)
        IdCorporation: item.IdCorporation,
        IdOrganization: item.IdOrganization ?? item.OrganizationId,
        IdUserResponsible: item.IdUserResponsible ?? item.UserResponsibleId,
        corporacao: item.Corporation || '',
        organização: item.Organization || '',
        escalar: item.escalar,
        alerta: item.assunto,
        nivel: item.Level,
        tipo: item.Tag,
        responsavel: item.UserResponsible,
        Gateway: item.Gateway,
        Local: item.Place,
        alertaMinutos: item.DelayToStart_minutes,
        solucaoMinutos: item.TimeToResolve_minutes,
        respostaMinutos: 100,
        ativo: item.Prism,
        IdDashboard: item.IdDashboard,
      }));
      return formattedData;
    } catch (error) {
      console.error("Erro ao buscar dados da API prismAlerts:", error);
      return [];
    }
  };

  const fetchPrismAlerts2 = async () => {
    try {
      const url = `${backendUrl}/api/PrismAlerts/GetByStatus?status=1${selectedOrganization ? `&org=${encodeURIComponent(selectedOrganization)}` : ''}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Erro HTTP! Status: ${response.status}`);
      const apiData = await response.json();
      const formattedData = apiData.map((item: any) => ({
        id: item.Id,
        IdPrism: item.IdPrism, // ID do Ativo
        IdCorporation: item.IdCorporation,
        IdOrganization: item.IdOrganization ?? item.OrganizationId,
        IdUserResponsible: item.IdUserResponsible ?? item.UserResponsibleId,
        corporacao: item.Corporation || '',
        organização: item.Organization || '',
        escalar: item.escalar,
        alerta: item.assunto,
        nivel: item.Level,
        tipo: item.Tag,
        responsavel: item.UserResponsible,
        Gateway: item.Gateway,
        Local: item.Place,
        alertaMinutos: item.DelayToStart_minutes,
        solucaoMinutos: item.TimeToResolve_minutes,
        respostaMinutos: 100,
        ativo: item.Prism,
        IdDashboard: item.IdDashboard,
      }));
      return formattedData;
    } catch (error) {
      console.error("Erro ao buscar dados da API prismAlerts:", error);
      return [];
    }
  };

  const fetchPlaceAlerts = async () => {
    try {
      const url = `${backendUrl}/api/PlaceAlerts/GetByStatus?status=0${selectedOrganization ? `&org=${encodeURIComponent(selectedOrganization)}` : ''}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Erro HTTP! Status: ${response.status}`);
      const apiData = await response.json();
      console.log('PlaceAlerts API response (status=0):', apiData);
      const formattedData = apiData.map((item: any) => ({
        id: item.Id, // Mantém o id original
        IdPlace: item.Id, // Identificador único para alertas Place
        IdCorporation: item.IdCorporation,
        IdOrganization: item.IdOrganization ?? item.OrganizationId,
        IdUserResponsible: item.IdUserResponsible ?? item.UserResponsibleId,
        IdGateway: item.IdGateway ?? item.GatewayId,
        corporacao: item.Corporation || '',
        organização: item.Organization || '',
        escalar: "",
        alerta: item.subject,
        nivel: item.Level,
        responsavel: item.UserResponsible,
        tipo: item.Tag,
        gateway: item.Gateway,
        Local: item.Place,
        alertaMinutos: item.DelayToStart_minutes,
        solucaoMinutos: item.TimeToResolve_minutes,
        respostaMinutos: 100,
        ativo: item.Prism,
        IdDashboard: item.IdDashboard,
      }));
      return formattedData;
    } catch (error) {
      console.error("Erro ao buscar dados da API placeAlerts:", error);
      return [];
    }
  };

  const fetchPlaceAlerts2 = async () => {
    try {
      const url = `${backendUrl}/api/PlaceAlerts/GetByStatus?status=1${selectedOrganization ? `&org=${encodeURIComponent(selectedOrganization)}` : ''}`;
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Erro HTTP! Status: ${response.status}`);
      const apiData = await response.json();
      console.log('PlaceAlerts API response (status=1):', apiData);
      const formattedData = apiData.map((item: any) => ({
        id: item.Id, // Mantém o id original
        IdPlace: item.Id, // Identificador único para alertas Place
        IdCorporation: item.IdCorporation,
        IdOrganization: item.IdOrganization ?? item.OrganizationId,
        IdUserResponsible: item.IdUserResponsible ?? item.UserResponsibleId,
        IdGateway: item.IdGateway ?? item.GatewayId,
        corporacao: item.Corporation || '',
        organização: item.Organization || '',
        escalar: "",
        alerta: item.subject,
        nivel: item.Level,
        responsavel: item.UserResponsible,
        tipo: item.Tag,
        gateway: item.Gateway,
        Local: item.Place,
        alertaMinutos: item.DelayToStart_minutes,
        solucaoMinutos: item.TimeToResolve_minutes,
        respostaMinutos: 100,
        ativo: item.Prism,
        IdDashboard: item.IdDashboard,
      }));
      return formattedData;
    } catch (error) {
      console.error("Erro ao buscar dados da API placeAlerts:", error);
      return [];
    }
  };

  const fetchAllAlerts = async () => {
    const [prismAlerts, placeAlerts, prismAlerts2, placeAlerts2] = await Promise.all([
      fetchPrismAlerts(),
      fetchPlaceAlerts(),
      fetchPrismAlerts2(),
      fetchPlaceAlerts2()
    ]);
    setPrismDataAll(prismAlerts);
    setPlaceDataAll(placeAlerts);
    setPrismData2All(prismAlerts2);
    setPlaceData2All(placeAlerts2);
    setAlertsLoaded(true);
  };

  // Buscar ao carregar usuários e ao mudar o filtro de organização
  useEffect(() => {
    if (users.length > 0) fetchAllAlerts();
  }, [users, selectedOrganization]);



  // Função para salvar uma linha (POST ou PUT)
  const handleSave = async (rowData: any, isPrismType: boolean) => {
    try {
      const endpoint = isPrismType
        ? !rowData.id ? `${backendUrl}/api/PrismAlerts` : `${backendUrl}/api/PrismAlerts/${rowData.id}`
        : !rowData.id ? `${backendUrl}/api/PlaceAlerts` : `${backendUrl}/api/PlaceAlerts/${rowData.id}`;

      const method = !rowData.id ? "POST" : "PUT";

      // Campos comuns aos dois tipos
      const commonBody = {
        IdCorporation: rowData.IdCorporation,
        IdOrganization: rowData.IdOrganization,
        IdDashboard: rowData.IdDashboard,
        IdAlertLevels: rowData.nivel,
        DelayToStart_minutes: rowData.alertaMinutos,
        TimeToResolve_minutes: rowData.solucaoMinutos,
        IdUserResponsible: rowData.IdUserResponsible,
      };

      // Construção do Body específico
      let requestBody;

      if (isPrismType) {
        requestBody = {
            ...commonBody,
            IdPrism: rowData.ativo, // ID do Ativo selecionado
        };
      } else {
        requestBody = {
            ...commonBody,
            IdGateway: rowData.IdGateway, // ID do Gateway selecionado
            IdTagPlace: rowData.tipo,     // Tipo (Fixo, Móvel, etc) é obrigatório para Gateway
        };
      }

      console.log("Enviando payload:", requestBody);

      const response = await fetch(endpoint, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestBody),
      });

      if (!response.ok) throw new Error("Erro ao salvar");
      
      setIsModalOpen(false); // Fecha o modal
      fetchAllAlerts();      // Atualiza a tabela
    } catch (error) {
      console.error("Erro ao salvar:", error);
    }
  };

  // Funções para abrir o modal
  const handleEditClick = (rowData: any, isPrism: any) => {
    // Fallbacks to ensure modal fields are prefilled even if some IDs aren't present in the row
    let resolvedUserId = rowData.IdUserResponsible;
    if (!resolvedUserId && rowData.responsavel && Array.isArray(users)) {
      const u = (users as any[]).find((x: any) => String(x.Name).trim() === String(rowData.responsavel).trim());
      if (u) resolvedUserId = u.Id;
    }

    let resolvedGatewayId = rowData.IdGateway;
    if (!isPrism && !resolvedGatewayId && rowData.gateway && Array.isArray(gateways)) {
      const g = (gateways as any[]).find((x: any) => String(x.SerialNumber).trim() === String(rowData.gateway).trim());
      if (g) resolvedGatewayId = g.Id;
    }

    let resolvedOrgId = rowData.IdOrganization;
    if (!resolvedOrgId && rowData.organização && rowData.IdCorporation && Array.isArray(organizationsFilter)) {
      const org = (organizationsFilter as any[]).find((o: any) => String(o.name).trim() === String(rowData.organização).trim() && String(o.corpId) === String(rowData.IdCorporation));
      if (org) resolvedOrgId = org.id;
    }

    // Normalize tipo if string label instead of numeric value
    let resolvedTipo = rowData.tipo;
    if (typeof resolvedTipo === 'string') {
      const tipoList = isPrism ? tipoPrismOptions : tipoPlaceOptions;
      const opt = tipoList.find((o: any) => o.label.toLowerCase() === resolvedTipo.toLowerCase());
      if (opt) resolvedTipo = opt.value;
    }

    // Normalize nivel if string label instead of numeric value
    let resolvedNivel = rowData.nivel;
    if (typeof resolvedNivel === 'string') {
      const optN = nivelOptions.find((o: any) => o.label.toLowerCase() === resolvedNivel.toLowerCase());
      if (optN) resolvedNivel = optN.value;
    }

    const patched = {
      ...rowData,
      IdUserResponsible: resolvedUserId ?? rowData.IdUserResponsible,
      IdGateway: resolvedGatewayId ?? rowData.IdGateway,
      IdOrganization: resolvedOrgId ?? rowData.IdOrganization,
      tipo: resolvedTipo,
      nivel: resolvedNivel,
      id: isPrism ? rowData.IdPrism : rowData.IdPlace,
    };

    setCurrentRow(patched);
    setIsPrism(isPrism);
    setIsModalOpen(true);
  };

const handleConfirmDelete = async () => {
  if (!rowToDelete) return;
  try {
    const endpoint = isPrism
      ? `${backendUrl}/api/PrismAlerts/ChangeStatus?id=${rowToDelete.id}`
      : `${backendUrl}/api/PlaceAlerts/ChangeStatus?id=${rowToDelete.id}`;
    const response = await fetch(endpoint, {
      method: "GET",
      headers: { "Content-Type": "application/json" },
    });
    if (!response.ok) throw new Error("Erro ao deletar o alerta");
    setIsDeleteModalOpen(false);
    setRowToDelete(null);
    // Recarrega apenas as tabelas do tipo correto (Prism ou Place)
    if (isPrism) {
      const [prismAlerts, prismAlerts2] = await Promise.all([
        fetchPrismAlerts(),
        fetchPrismAlerts2()
      ]);
      setPrismDataAll(prismAlerts);
      setPrismData2All(prismAlerts2);
    } else {
      const [placeAlerts, placeAlerts2] = await Promise.all([
        fetchPlaceAlerts(),
        fetchPlaceAlerts2()
      ]);
      setPlaceDataAll(placeAlerts);
      setPlaceData2All(placeAlerts2);
    }
  } catch (error) {
    console.error("Erro ao deletar o alerta:", error);
    setIsDeleteModalOpen(false);
    setRowToDelete(null);
  }
};

  const handleAddClick = (isPrism: any) => {
    setCurrentRow(null);
    setIsPrism(isPrism);
    setIsModalOpen(true);
  };

  // Renderização da tabela Prism

  useEffect(() => {
    if (activeTab === 'ativos' && prismTableRef.current) {
      prismTableInstance.current = new Tabulator(prismTableRef.current, {
        data: prismData,
        layout: "fitData",
        pagination: false,
        columns: [
          {
            title: "",
            field: "actions",
            width: 100,
            formatter: () =>
              `<i class="ui icon edit" style="cursor: pointer; margin-right:8px;"></i>
              <i class="ui icon check circle outline" style="cursor: pointer;"></i>`,
            cellClick: (e, cell) => {
              const target = (e.target as HTMLElement);
              const rowData = cell.getRow().getData();
              if (target.classList.contains("edit")) {
                handleEditClick(rowData, true);
              } else if (target.classList.contains("check")) {
                setRowToDelete(rowData);
                setIsDeleteModalOpen(true);
                setIsPrism(true);
              }
            },
          },
          { title: "Corporação", field: "corporacao", width: 200 },
          { title: "Organização", field: "organização", width: 200 },
          {
            title: "Escalar",
            field: "escalar",
            width: 120,
            formatter: (cell) => {
              const rowData = cell.getRow().getData();
              const count = prismEscalate.filter(e => String(e.IdPrismAlerts) === String(rowData.id)).length;
              return `
              <button class="escalar-button" data-id="${rowData.id}" data-type="prism">
                <span class="escalar-text">➡️ ${count}</span>
              </button>
            `;
            },
          },
          {
            title: "Alerta",
            field: "IdDashboard",
            width: 282,
            formatter: (cell) => {
              const rowData = cell.getRow().getData();
              const dashboard = dashboardAlerts.find(d => String(d.Id) === String(rowData.IdDashboard));
              return dashboard ? dashboard.Titulo : "(não encontrado)";
            }
          },
          { title: "Nível", field: "nivel", width: 100 },
          { title: "Tipo", field: "tipo", width: 100 },
          { title: "Ativo", field: "ativo", width: 150 },
          { title: "Alerta (minutos)", field: "alertaMinutos", width: 150 },
          { title: "Solução (minutos)", field: "solucaoMinutos", width: 150 },
          { title: "Resposta (minutos)", field: "respostaMinutos", width: 150 },
          { title: "Responsável", field: "responsavel", width: 268 }
        ],
      });

      // Adicionar evento de clique ao botão de escalar
      prismTableInstance.current.on("tableBuilt", () => {
        const buttons = prismTableRef.current?.querySelectorAll(".escalar-button");
        buttons?.forEach((button) => {
          button.addEventListener("click", (e) => {
            const id = button.getAttribute("data-id");
            window.location.href = `/escalar-alerta-ativo?idPrismAlert=${id}`;
          });
        });
      });
    }
    }, [prismData, activeTab]);

    // Renderização da tabela Prism2

  useEffect(() => {
    if (activeTab === 'ativos' && prismTableRef2.current) {
      prismTableInstance.current = new Tabulator(prismTableRef2.current, {
        data: prismData2,
        layout: "fitData",
        pagination: false,
        columns: [
          {
            title: "",
            field: "actions",
            width: 100,
            formatter: () =>
              `<i class="ui icon edit" style="cursor: pointer; margin-right:8px;"></i>
              <i class="ui icon circle outline" style="cursor: pointer;"></i>`,
            cellClick: (e, cell) => {
              const target = (e.target as HTMLElement);
              const rowData = cell.getRow().getData();
              if (target.classList.contains("edit")) {
                handleEditClick(rowData, true);
              } else if (target.classList.contains("circle")) {
                setRowToDelete(rowData);
                setIsEnableModalOpen(true);
                setIsPrism(true);
              }
            },
          },
          { title: "Corporação", field: "corporacao", width: 200 },
          { title: "Organização", field: "organização", width: 200 },
          {
            title: "Escalar",
            field: "escalar",
            width: 120,
            formatter: (cell) => {
              const rowData = cell.getRow().getData();
              const count = prismEscalate.filter(e => String(e.IdPrismAlerts) === String(rowData.id)).length;
              return `
              <button class="escalar-button" data-id="${rowData.id}" data-type="prism">
                <span class="escalar-text">➡️ ${count}</span>
              </button>
            `;
            },
          },
          {
            title: "Alerta",
            field: "IdDashboard",
            width: 282,
            formatter: (cell) => {
              const rowData = cell.getRow().getData();
              const dashboard = dashboardAlerts.find(d => String(d.Id) === String(rowData.IdDashboard));
              return dashboard ? dashboard.Titulo : "(não encontrado)";
            }
          },
          { title: "Nível", field: "nivel", width: 100 },
          { title: "Tipo", field: "tipo", width: 100 },
          { title: "Ativo", field: "ativo", width: 150 },
          { title: "Local", field: "Local", width: 150 },
          { title: "Alerta (minutos)", field: "alertaMinutos", width: 150 },
          { title: "Solução (minutos)", field: "solucaoMinutos", width: 150 },
          { title: "Resposta (minutos)", field: "respostaMinutos", width: 150 },
          { title: "Responsável", field: "responsavel", width: 268 }
        ],
      });

      // Adicionar evento de clique ao botão de escalar
      prismTableInstance.current.on("tableBuilt", () => {
        const buttons = prismTableRef.current?.querySelectorAll(".escalar-button");
        buttons?.forEach((button) => {
          button.addEventListener("click", (e) => {
            const id = button.getAttribute("data-id");
            window.location.href = `/escalar-alerta-ativo?idPrismAlert=${id}`;
          });
        });
      });
    }
    }, [prismData2, activeTab]);


  // Renderização da tabela Place
  useEffect(() => {
    if (activeTab === 'gateways' && placeTableRef.current) {
      placeTableInstance.current = new Tabulator(placeTableRef.current, {
        data: placeData,
        layout: "fitData",
        pagination: false,
        columns: [
                    {
            title: "",
            field: "actions",
            width: 100,
            formatter: () =>
              `<i class="ui icon edit" style="cursor: pointer; margin-right:8px;"></i>
              <i class="ui icon check circle outline" style="cursor: pointer;"></i>`,
            cellClick: (e, cell) => {
              const target = (e.target as HTMLElement);
              const rowData = cell.getRow().getData();
              if (target.classList.contains("edit")) {
                handleEditClick(rowData, false);
              } else if (target.classList.contains("check")) {
                setRowToDelete(rowData);
                setIsPrism(false);
                setIsDeleteModalOpen(true);
              }
            },
          },
          { title: "Corporação", field: "corporacao", width: 200 },
          { title: "Organização", field: "organização", width: 200 },
          {
            title: "Escalar",
            field: "escalar",
            width: 120,
            formatter: (cell) => {
              const rowData = cell.getRow().getData();
              const count = placeEscalate.filter(e => String(e.IdPlaceAlerts) === String(rowData.id)).length;
              return `
      <button class="escalar-button" data-id="${rowData.id}" data-type="place">
        <span class="escalar-text">➡️${count}</span>
      </button>
    `;
            },
          },
          {
            title: "Alerta",
            field: "IdDashboard",
            width: 282,
            formatter: (cell) => {
              const rowData = cell.getRow().getData();
              const dashboard = dashboardAlerts.find(d => String(d.Id) === String(rowData.IdDashboard));
              return dashboard ? dashboard.Titulo : "(não encontrado)";
            }
          },
          { title: "Nível", field: "nivel", width: 100 },
          { title: "Tipo", field: "tipo", width: 98 },
          { title: "Local", field: "Local", width: 140 },
          { title: "Gateway", field: "gateway", width: 110 },
          { title: "Alerta (minutos)", field: "alertaMinutos", width: 140 },
          { title: "Solução (minutos)", field: "solucaoMinutos", width: 140 },
          { title: "Resposta (minutos)", field: "respostaMinutos", width: 140 },
          { title: "Responsável", field: "responsavel", width: 200 }
        ],
      });
    }
    }, [placeData, activeTab]);

  useEffect(() => {
    if (activeTab === 'gateways' && placeTableRef2.current) {
      placeTableInstance.current = new Tabulator(placeTableRef2.current, {
        data: placeData2,
        layout: "fitData",
        pagination: false,
        columns: [
                    {
            title: "",
            field: "actions",
            width: 100,
            formatter: () =>
              `<i class="ui icon edit" style="cursor: pointer; margin-right:8px;"></i>
              <i class="ui icon circle outline" style="cursor: pointer;"></i>`,
            cellClick: (e, cell) => {
              const target = (e.target as HTMLElement);
              const rowData = cell.getRow().getData();
              if (target.classList.contains("edit")) {
                handleEditClick(rowData, false);
              } else if (target.classList.contains("circle")) {
                setRowToDelete(rowData);
                setIsPrism(false);
                setIsEnableModalOpen(true);
              }
            },
          },
          { title: "Corporação", field: "corporacao", width: 200 },
          { title: "Organização", field: "organização", width: 200 },
          {
            title: "Escalar",
            field: "escalar",
            width: 120,
            formatter: (cell) => {
              const rowData = cell.getRow().getData();
              const count = placeEscalate.filter(e => String(e.IdPlaceAlerts) === String(rowData.id)).length;
              return `
      <button class="escalar-button" data-id="${rowData.id}" data-type="place">
        <span class="escalar-text">➡️${count}</span>
      </button>
    `;
            },
          },
          {
            title: "Alerta",
            field: "IdDashboard",
            width: 282,
            formatter: (cell) => {
              const rowData = cell.getRow().getData();
              const dashboard = dashboardAlerts.find(d => String(d.Id) === String(rowData.IdDashboard));
              return dashboard ? dashboard.Titulo : "(não encontrado)";
            }
          },
          { title: "Nível", field: "nivel", width: 100 },
          { title: "Tipo", field: "tipo", width: 98 },
          { title: "Local", field: "Local", width: 140 },
          { title: "Gateway", field: "gateway", width: 110 },
          { title: "Alerta (minutos)", field: "alertaMinutos", width: 140 },
          { title: "Solução (minutos)", field: "solucaoMinutos", width: 140 },
          { title: "Resposta (minutos)", field: "respostaMinutos", width: 140 },
          { title: "Responsável", field: "responsavel", width: 200 }
        ],
      });

      // Adicionar evento de clique ao botão de escalar
      placeTableInstance.current.on("tableBuilt", () => {
        const buttons = placeTableRef.current?.querySelectorAll(".escalar-button");
        buttons?.forEach((button) => {
          button.addEventListener("click", (e) => {
            const id = button.getAttribute("data-id");
            window.location.href = `/escalar-alerta-gateway?idPlaceAlert=${id}`;
          });
        });
      });
    }
    }, [placeData2, activeTab]);

  // Classes CSS usando variáveis do bootstrap para suporte a temas claro/escuro
  const classes = {
    title: "fs-2 text-body mb-4",
    addButton: "btn btn-primary mb-4 w-auto",
    tabContainer: "nav nav-tabs mb-4",
    tab: "nav-link",
    activeTab: "nav-link active",
    // Modal classes
    modalOverlay: "modal-backdrop position-fixed top-0 start-0 end-0 bottom-0 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center z-3",
    modalContent: "modal-content bg-body p-4 rounded shadow-lg w-100 mw-md",
    modalTitle: "modal-title fs-4 mb-4 text-body fw-bold",
    subtitle: "fs-4 text-body fw-bold my-4",
    form: "d-flex flex-column gap-3",
    formGroup: "form-group",
    label: "form-label text-body mb-1",
    input: "form-control",
    select: "form-select",
    buttonGroup: "d-flex gap-2 mt-4",
    buttonPrimary: "btn btn-primary",
    buttonSecondary: "btn btn-outline-secondary",
    buttonDanger: "btn btn-danger",
  };

  return (
  <div>
    <h1 className={classes.title}>Gestão de Alertas</h1>
    
    <div className="d-flex gap-3 align-items-center mb-3">
      <div>
        <label className={classes.label}>Corporação</label>
        <select
          value={selectedCorporation}
          onChange={(e) => {
            setSelectedCorporation(e.target.value);
            setSelectedOrganization('');
          }}
          className={classes.select}
        >
          <option value="">Todas</option>
          {corporationsFilter.map((c) => (
            <option key={c.id} value={c.id}>{c.name}</option>
          ))}
        </select>
      </div>
    </div>

    <div className={classes.tabContainer}>
      <button
        className={activeTab === 'ativos' ? classes.activeTab : classes.tab}
        onClick={() => setActiveTab('ativos')}
      >
        Ativos
      </button>
      <button
        className={activeTab === 'gateways' ? classes.activeTab : classes.tab}
        onClick={() => setActiveTab('gateways')}
      >
        Gateways
      </button>
    </div>

    {activeTab === 'ativos' && (
      <>
        <button
          onClick={() => handleAddClick(true)}
          className={classes.addButton}
        >
          Adicionar Alerta Ativo
        </button>
        <h2 className={classes.subtitle}>Alertas Ativados</h2>
        <div ref={prismTableRef} className="mb-4"></div>
        <h2 className={classes.subtitle}>Alertas Desativados</h2>
        <div ref={prismTableRef2}></div>
      </>
    )}

    {isDeleteModalOpen && (
      <div className={classes.modalOverlay}>
        <div className={classes.modalContent}>
          <h2 className={classes.modalTitle}>Desabilitar o Alerta</h2>
          <p className="text-body">Tem certeza que deseja desabilitar este alerta?</p>
          <div className={classes.buttonGroup}>
            <button
              className={classes.buttonDanger}
              onClick={handleConfirmDelete}
            >
              Desabilitar
            </button>
            <button
              className={classes.buttonSecondary}
              onClick={() => {
                setIsDeleteModalOpen(false);
                setRowToDelete(null);
              }}
            >
              Cancelar
            </button>
          </div>
        </div>
      </div>
    )}

      {isEnableModalOpen && (
        <div className={classes.modalOverlay}>
          <div className={classes.modalContent}>
            <h2 className={classes.modalTitle}>Habilitar o Alerta</h2>
            <p>Tem certeza que deseja habilitar este alerta?</p>
            <div className={classes.buttonGroup}>
              <button
                className={classes.buttonPrimary}
                onClick={async () => {
            await handleConfirmDelete();
            setIsEnableModalOpen(false);
          }}
              >
                Habilitar
              </button>
              <button
                className={classes.buttonSecondary}
                onClick={() => {
                  setIsEnableModalOpen(false);
                  setRowToDelete(null);
                }}
              >
                Cancelar
              </button>
            </div>
          </div>
        </div>
      )}

      {activeTab === 'gateways' && (
        <>
          <button
            onClick={() => handleAddClick(false)}
            className={classes.addButton}
          >
            Adicionar Alerta Gateway
          </button>
          <h2 className="fs-4 text-body fw-bold my-4">Alertas Ativados</h2>
          <div ref={placeTableRef} style={{ marginBottom: '20px' }}></div>
          <h2 className="fs-4 text-body fw-bold my-4">Alertas Desativados</h2>
          <div ref={placeTableRef2}></div>
        </>

      )}

      <AlertModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleSave}
        initialData={currentRow}
        isPrism={isPrism}
        dashboardAlerts={dashboardAlerts}
        users={users}
    />
    </div>
  );
};





export default MenuListaAlertas;